module.exports = __webpack_public_path__ + "img/not-authorized-dark.d173ef78.svg";